import React, { useEffect } from "react";
import { HeroPage } from "./HeroPage";
import UpcomingEvents from "../Events/UpcominEvents";
import Ministries from "../Ministries/Ministries";
import Ministries2 from "../Ministries/Ministries2";
import Services from "../Services/Services";
import Footer from "../reusable/Footer";
import ChurchServices from "../Services/ChurchServices";
import ServicesTabs from "../Services/ServiceTabs";
import OutReachMission from "../OutReachMission/OutReachMission";
import Pastors from "../Pastors/Pastors";
import { useLocation } from "react-router-dom";
import { scroller } from 'react-scroll';

export const Home = () => {
    const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        scroller.scrollTo(id, {
          duration: 800,
          smooth: 'easeInOutQuart',
          offset: -70, // optional if navbar overlaps
        });
      }, 100);
    }
  }, [location]);
  return (
    <div>
      <HeroPage id="home" />
      <UpcomingEvents id="events" />
      <Ministries id="ministries" />
      {/* <Ministries2 /> */}
      {/* <Services /> */}
      {/* <ChurchServices /> */}
      <ServicesTabs id="services" />
      <OutReachMission id="outreach" />
      <Pastors id="pastors" />
      <Footer />
    </div>
  );
};
